/* @flow */
const productRoutes = {
  addForUser: 'products/add-for-user',
  activity: 'products/:productGuid/activity',
};

export default productRoutes;
